<div [bfx-input]="bfxInput" [ngClass]="inputDirective.classes" #input>
  <div class="bfx-input-label">
    <ng-container
      [ngTemplateOutlet]="inputStartContainer"
      [ngTemplateOutletContext]="{'$implicit': chkBoxLabel}"
    ></ng-container>
    <div [ngClass]="inputDirective.labelClasses" #chkBoxLabel>
      {{inputLabelText}}<span *ngIf="required">*</span>
    </div>
    <ng-container
      [ngTemplateOutlet]="inputEndContainer"
      [ngTemplateOutletContext]="{'$implicit': chkBoxLabel}"
    ></ng-container>
  </div>
  <div [ngClass]="inputDirective.innerClasses">
    <div
      [bfx-field-text]="bfxFieldText"
      [ngClass]="fieldDirective.classes"
      [style.display]="hideField ? 'none' : 'flex'"
    >
      <!-- start enhancer -->
      <ng-container *ngTemplateOutlet="fieldStartContainer"></ng-container>
      <input
        #text
        [ngClass]="fieldDirective.inputClasses"
        (change)="onChange($event)"
        (pointerover)="onPointerOver($event)"
        (pointerout)="onPointerOut($event)"
        (focus)="onFocus($event)"
        (blur)="onBlur($event)"
        [attr.disabled]="disabled ? '' : null"
        (input)="onInput($event)"
        [(ngModel)]="value"
        [ngModelOptions]="{standalone: true}"
        [type]="password ? 'password' : 'search'"
        [required]="required ? 'required' : null"
        [maxLength]="maxLength"
        [title]="value ?? ''"
        [placeholder]="placeholder ?? ''"
        autocomplete="off"
      />

      <!-- clear button -->
      <!-- end enhancer  -->
      <bfx-icon-button
        [style.visibility]="fieldDirective.hasEndIcon()?'visible':'hidden'"
        [parentSize]="size"
        [iconClass]="fieldDirective.endIconClasses"
        tabindex="-1"
        [disabled]="disabled"
        (action)="onFieldIconClick($event, 'end', 0)"
      ></bfx-icon-button>
      <ng-container *ngTemplateOutlet="fieldEndContainer"></ng-container>
    </div>
  </div>
</div>
